const initialState = () => ({
  channels: [],
  channel: {},
});

const state = initialState();

export default state;
